import axios from 'axios';

export const saveUserInfo = async (userInfo, email = 'noahstotland@gmail.com', isNotifications = false) => {
	// for (const row of userInfo) {
	// 	const diffTime = Math.abs(new Date() - new Date(row.date));
	// 	const dateDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	// 	row.dateDifference = dateDifference;
	// }
	// const diffTime = Math.abs(new Date() - new Date(userInfo.date));
	// const dateDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	// userInfo.dateDifference = dateDifference;
	const accessToken = window.localStorage.getItem('access_token');

	const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/save_user_info?email=${email}&is_notifications=${isNotifications}`, userInfo, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	// update localstorage with the new bankroll
	const user = JSON.parse(window.localStorage.getItem('userdb'));
	user.user_data = userInfo;

	if (!user.queries) {
		user.queries = [userInfo];
	}

	// console.log('userInfo: ', userInfo);
	// for (const r of user.user_data) {
	// 	r.bankroll = userInfo[0].bankroll;
	// }
	// if (!isNotifications) {
	// 	user.queries = [userInfo];

	// 	if (user.queries?.[0]?.[0]) {
	// 		// console.log('JSON.stringify(user): ', user);

	// 		window.localStorage.setItem('userdb', JSON.stringify(user));
	// 	}
	// } else {
	user.notifications_query = userInfo;

	// TODO: handle updating of the query name
	for (let i = 0; i < user.queries.length; i++) {
			// console.log('user.queries[i].name: ', user.queries[i][0].name, userInfo[0].name);

		if (user.queries[i][0].name === userInfo[0].name) {
			user.queries[i] = userInfo;
		}
	}

	window.localStorage.setItem('userdb', JSON.stringify(user));
	// }

	return res;
};

export const saveUserInfoArbitrage = async (userInfo, email = 'noahstotland@gmail.com', isNotifications = false, defaultStake = 100) => {
	const accessToken = window.localStorage.getItem('access_token');

	const res = await axios.post(
		`${process.env.REACT_APP_BACKEND_URL}/save_user_info_arbitrage?email=${email}&is_notifications=${isNotifications}&default_stake=${defaultStake}`,
		userInfo,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		}
	);

	// update localstorage with the new bankroll
	const user = JSON.parse(window.localStorage.getItem('userdb'));
	user.user_data_arbitrage = userInfo;

	if (!user.query_arbitrage) {
		user.query_arbitrage = [userInfo];
	}

	window.localStorage.setItem('userdb', JSON.stringify(user));

	return res;
};

export const saveUserInfoOutliers = async (userInfo, email = 'noahstotland@gmail.com', isNotifications = false, defaultStake = 100) => {
	const accessToken = window.localStorage.getItem('access_token');

	const res = await axios.post(
		`${process.env.REACT_APP_BACKEND_URL}/save_user_info_outliers?email=${email}&is_notifications=${isNotifications}&default_stake=${defaultStake}`,
		userInfo,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		}
	);

	// update localstorage with the new bankroll
	const user = JSON.parse(window.localStorage.getItem('userdb'));
	user.user_data_outliers = userInfo;

	if (!user.query_outliers) {
		user.query_outliers = [userInfo];
	}

	window.localStorage.setItem('userdb', JSON.stringify(user));

	return res;
};
